import { ElementType, GlobalConfig } from "../types/builder";

const generateId = (): string => {
  return Math.random().toString(36).substr(2, 9);
};

export const template3GlobalConfig: GlobalConfig = {
  typography: [
    {
      name: "Default",
      fontFamily: "Open Sans",
      fontSize: "16px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    {
      name: "Heading-1",
      fontFamily: "Source Serif 4",
      fontSize: "64px",
      fontWeight: "600",
      fontStyle: "normal",
    },
    {
      name: "Heading-2",
      fontFamily: "Open Sans",
      fontSize: "50px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Heading-3",
      fontFamily: "Open Sans",
      fontSize: "34px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Heading-4",
      fontFamily: "Open Sans",
      fontSize: "28px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Heading-5",
      fontFamily: "Open Sans",
      fontSize: "22px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Heading-6",
      fontFamily: "Open Sans",
      fontSize: "20px",
      fontWeight: "700",
      fontStyle: "normal",
    },
    {
      name: "Body",
      fontFamily: "Open Sans",
      fontSize: "18px",
      fontWeight: "400",
      fontStyle: "normal",
    },
    {
      name: "Button",
      fontFamily: "Open Sans",
      fontSize: "16px",
      fontWeight: "600",
      fontStyle: "normal",
    },
  ],
  colors: {
    background: "#FFFFFF",
    forground: "#000000",
    primary: "#7C3AED",
    secondary: "#1E291D",
    tertiary: "#101F0F",
    quaternary: "#5DB74C",
    link: "#009DFF",
    activeLink: "#1D4ED8",
  },
  breakpoints: {
    mobileMax: 640,
    tabletMin: 641,
    tabletMax: 1024,
    desktopMin: 1025,
  },
};

const createHeaderContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    height: "80px",
    padding: "0px 56px",
    justifyContent: "space-between",
    alignItems: "center",
    alignSelf: "stretch",
    borderBottom: "1px solid #DDD",
    backgroundColor: "background",
    backdropFilter: "blur(12px)",
  },
  responsiveStyles: {
    tablet: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
    mobile: {
      padding: "0px",
      maxWidth: "95%",
      margin: "0 auto",
    },
  },
  children: [
    // Logo
    {
      id: generateId(),
      type: "logo" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/logo.png", // <-- Update this path to your logo
          alt: "Logo",
          styles: {
            width: "78px",
            height: "64px",
            objectFit: "contain",
          },
        },
      ],
    },
    // Navigation
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "36px",
        flex: "1",
        justifyContent: "center",
      },
      responsiveStyles: {
        tablet: {
          display: "none",
        },
        mobile: {
          display: "none",
        },
      },
      children: [
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "Über Klosterformel",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            color: "#8B938B",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "Preis",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            color: "#8B938B",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "Zutaten",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            color: "#8B938B",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "Häufig Gestellte Fragen",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            color: "#8B938B",
            margin: "0",
          },
          typography: "Default",
        },
      ],
    },
    // Button
    {
      id: generateId(),
      type: "button" as ElementType,
      content: "Jetzt Bestellen",
      styles: {
        display: "flex",
        height: "48px",
        padding: "0px 28px",
        justifyContent: "center",
        alignItems: "center",
        gap: "8px",
        borderRadius: "60px",
        backgroundColor: "secondary",
        boxShadow: "0px 0px 0px 4px #101f0f1a",
        color: "background",
        fontFamily: "Open Sans",
        fontWeight: "400",
        fontSize: "16px",
        border: "none",
        margin: "0 0 0 auto",
      },
      typography: "Default",
    },
    //Hamburger Button
    {
      id: generateId(),
      type: "button" as ElementType,
      content: "☰",
      interactionType: "popup",
      triggerPopup: "mobile-navigation",
      styles: {
        display: "none", // Hidden on desktop
        width: "44px",
        height: "44px",
        borderRadius: "50%",
        backgroundColor: "#F3F3F3",
        border: "none",
        alignItems: "center",
        justifyContent: "center",
        padding: "0",
        cursor: "pointer",
        boxShadow: "0px 2px 8px #0000000a",
        marginLeft: "12px",
        fontSize: "18px",
        color: "#333",
      },
      responsiveStyles: {
        tablet: {
          display: "flex",
        },
        mobile: {
          display: "flex",
        },
      },
    },
  ],
});

const createFirstSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    backgroundImage: "url('/template3/background-paper.png')",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    backgroundPosition: "center",
    padding: "0 70px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "849px",
    width: "100%",
    boxSizing: "border-box",
    position: "relative",
  },
  responsiveStyles: {
    tablet: {
      padding: "0px 12px",
      minHeight: "500px",
    },
    mobile: {
      padding: "0px 12px",
      minHeight: "500px",
      backgroundSize: "cover",
      backgroundPosition: "left center",
      flexDirection: "column",
    },
  },
  children: [
    // Left Side
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        width: "65%",
        gap: "33px",
        marginTop: "-12%",
      },
      responsiveStyles: {
        tablet: {
          gap: "16px",
          marginTop: "-5%",
        },
        mobile: {
          gap: "20px",
          width: "100%",
          marginTop: "0%",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          alt: "section-first-left",
          styles: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "flex-start",
            gap: "16px",
          },
          responsiveStyles: {
            tablet: {
              gap: "0",
            },
            mobile: {
              gap: "0",
            },
          },
          children: [
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "Natürlich. Wirksam. Echt",
              styles: {
                color: "tertiary",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "26px",
              },
              typography: "Body",
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              alt: "section-first-left",
              styles: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-start",
                gap: "0px",
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Aktiviere deinen Stoffwechsel.",
                  styles: {
                    color: "primary",
                    margin: "0",
                    textShadow: "0px 4px 4px #FFF",
                    fontFamily: '"Source Serif 4"',
                    fontSize: "64px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "66px",
                    letterSpacing: "-3.2px",
                  },
                  typography: "Heading-1",
                  responsiveStyles: {
                    tablet: {
                      fontSize: "44px",
                      lineHeight: "44px",
                    },
                    mobile: {
                      fontSize: "44px",
                      lineHeight: "44px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Verändere dein Leben.",
                  styles: {
                    color: "secondary",
                    fontFamily: '"Source Serif 4"',
                    fontSize: "64px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "66px",
                    letterSpacing: "-3.2px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "44px",
                      lineHeight: "44px",
                    },
                    mobile: {
                      fontSize: "44px",
                      lineHeight: "44px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/verandere-underline.svg",
                  alt: "Verändere dein Leben Underline",
                  styles: {
                    width: "254px",
                    position: "relative",
                    zIndex: "1",
                  },
                  responsiveStyles: {
                    tablet: {
                      maxWidth: "400px",
                    },
                    mobile: {
                      maxWidth: "300px",
                    },
                  },
                },
              ],
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Die Klosterformel verbindet altes Wissen mit moderner Wissenschaft – für spürbar mehr Energie, Leichtigkeit und Wohlbefinden im Alltag.",
          styles: {
            maxWidth: "515px",
            color: "primary",
            textShadow: "0px 4px 4px #FFF",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "26px",
          },
          typography: "Body",
        },
        {
          id: generateId(),
          type: "button" as ElementType,
          content: "Jetzt Klosterformel Testen!",
          styles: {
            display: "flex",
            height: "48px",
            padding: "0px 28px",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "60px",
            backgroundColor: "secondary",
            boxShadow: "0px 0px 0px 4px #3962351a",
            color: "background",
            fontFamily: "Montserrat",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "16px",
            marginBottom: "12px",
          },
          typography: "Body",
          responsiveStyles: {
            tablet: {
              marginBottom: "10px",
            },
            mobile: {
              marginBottom: "0px",
            },
          },
        },
        // Testimonial row
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            gap: "24px",
          },
          children: [
            // Avatars
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                gap: "-8px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person.png",
                  alt: "avatar1",
                  styles: {
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginLeft: "0",
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person.png",
                  alt: "avatar2",
                  styles: {
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginLeft: "-8px",
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person.png",
                  alt: "avatar3",
                  styles: {
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginLeft: "-8px",
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person.png",
                  alt: "avatar4",
                  styles: {
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginLeft: "-8px",
                  },
                },
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person.png",
                  alt: "avatar5",
                  styles: {
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    marginLeft: "-8px",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                gap: "6px",
                marginLeft: "12px",
              },
              children: [
                // Stars
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/star.png",
                  alt: "stars",
                  styles: {
                    width: "97px",
                    height: "16px",
                    flexShrink: "0",
                    objectFit: "contain",
                  },
                },
                // Testimonial text
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Unzählige Zufriedene Kunden",
                  styles: {
                    color: "#707070",
                    fontFamily: "Open Sans",
                    fontSize: "14px",
                    fontStyle: "normal",
                    fontWeight: "400",
                    lineHeight: "17.5px",
                  },
                },
              ],
            },
          ],
        },
      ],
    },
    // Right Side
    {
      id: generateId(),
      type: "container" as ElementType,
      interactionType: 'scroll-to-section',
      targetSectionId: 'pricing-section',
      scrollOffset: -100,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "35%",
        position: "relative",
      },
      responsiveStyles: {
        tablet: {
          width: "40%",
        },
        mobile: {
          width: "100%",
          marginTop: "20px",
        },
      },
      children: [
        // Bottle image
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/bottle.png",
          alt: "Klosterformel Bottle",
          styles: {
            width: "306px",
            height: "591px",
            objectFit: "contain",
            marginBottom: "20px",
          },
          responsiveStyles: {
            tablet: {
              width: "245px",
              height: "473px",
            },
            mobile: {
              width: "184px",
              height: "354px",
            },
          },
        },
        // Badges container below bottle
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "15px",
            flexWrap: "wrap",
            width: "100%",
            paddingTop: "10px",
          },
          responsiveStyles: {
            tablet: {
              gap: "12px",
            },
            mobile: {
              gap: "10px",
              justifyContent: "space-around",
            },
          },
          children: [
            // Guarantee badge
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/guarantee.png",
              alt: "Money Back Guarantee",
              styles: {
                width: "110px",
                height: "auto",
                objectFit: "contain",
              },
              responsiveStyles: {
                tablet: {
                  width: "75px",
                },
                mobile: {
                  width: "65px",
                },
              },
            },
            // Lab certification
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/lab.png",
              alt: "Lab Tested",
              styles: {
                width: "110px",
                height: "auto",
                objectFit: "contain",
              },
              responsiveStyles: {
                tablet: {
                  width: "75px",
                },
                mobile: {
                  width: "65px",
                },
              },
            },
            // Deutsche logo
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/deutsche.png",
              alt: "Deutsche Quality",
              styles: {
                width: "110px",
                height: "auto",
                objectFit: "contain",
              },
              responsiveStyles: {
                tablet: {
                  width: "75px",
                },
                mobile: {
                  width: "65px",
                },
              },
            },
          ],
        },
      ],
    },
  ],
});

const createBannerSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: "45px",
    height: "129px",
    flexShrink: "0",
    backgroundColor: "#F3F3F3",
  },
  responsiveStyles: {
    tablet: {
      height: "auto",
      padding: "20px",
      gap: "24px",
    },
    mobile: {
      height: "auto",
      padding: "15px",
      gap: "20px",
      flexDirection: "column",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "0px",
        maxWidth: "1115px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/banner1.svg",
          alt: "Vegan Icon",
          styles: {
            width: "21px",
            height: "37px",
            objectFit: "contain",
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Vegan",
          styles: {
            color: "secondary",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "150%",
            whiteSpace: "nowrap",
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "0px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/banner2.svg",
          alt: "Glutenfrei Icon",
          styles: {
            width: "33px",
            height: "40px",
            objectFit: "contain",
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Glutenfrei",
          styles: {
            color: "secondary",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "150%",
            whiteSpace: "nowrap",
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/banner3.svg",
          alt: "Ohne Gentechnik Icon",
          styles: {
            width: "24px",
            height: "26.5px",
            objectFit: "contain",
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Ohne Gentechnik",
          styles: {
            color: "secondary",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "150%",
            whiteSpace: "nowrap",
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/banner4.svg",
          alt: "Stoffwechsel Icon",
          styles: {
            width: "28.8px",
            height: "28.6px",
            objectFit: "contain",
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Stoffwechsel-Unterstützung",
          styles: {
            color: "secondary",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "150%",
            whiteSpace: "nowrap",
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "0px",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/banner5.svg",
          alt: "Gewichtsreduktion Icon",
          styles: {
            width: "37.1px",
            height: "44.5px",
            objectFit: "contain",
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Für Gewichtsreduktion",
          styles: {
            color: "secondary",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "150%",
            whiteSpace: "nowrap",
          },
        },
      ],
    },
  ],
});

const createDetailSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "background",
    width: "100%",
    boxSizing: "border-box",
    gap: "40px",
    padding: "87px 70px 18px 52px",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      margin: "0 auto",
      padding: "40px 0 18px",
      gap: "24px",
      flexDirection: "column",
    },
    mobile: {
      maxWidth: "95%",
      margin: "0 auto",
      padding: "20px 0",
      gap: "24px",
      flexDirection: "column",
    },
  },
  children: [
    // Left content
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "32px",
        flex: "1",
      },
      responsiveStyles: {
        tablet: {
          gap: "16px",
        },
        mobile: {
          gap: "16px",
          width: "100%",
        },
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/product-detail.png",
          alt: "Product Detail",
          styles: {
            width: "100%",
            objectFit: "contain",
            display: "none",
          },
          responsiveStyles: {
            tablet: {
              display: "block",
            },
            mobile: {
              display: "block",
            },
          },
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/man-emoji.svg",
              alt: "Leaf Icon",
              styles: {
                width: "19px",
                height: "26px",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content: "Die Original-Klosterformel",
              styles: {
                color: "tertiary",
                fontFamily: "Open Sans",
                fontSize: "16px",
                fontStyle: "normal",
                fontWeight: "400",
                lineHeight: "26px",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "heading" as ElementType,
          content: "Natürlich abnehmen – inspiriert von alten Klosterrezepten",
          styles: {
            color: "secondary",
            fontFamily: '"Source Serif 4"',
            fontSize: "61.4px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "66px",
          },
          responsiveStyles: {
            tablet: {
              fontSize: "45px",
              lineHeight: "48px",
            },
            mobile: {
              fontSize: "36px",
              lineHeight: "40px",
            },
          },
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Diese pflanzliche Mischung wurde nach überlieferten Manuskripten entwickelt – für alle, die ihrem Körper auf natürliche Weise beim Abnehmen helfen möchten.",
          styles: {
            color: "tertiary",
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "26px",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "button" as ElementType,
          content: "Jetzt Bestellen",
          styles: {
            width: "auto",
            display: "flex",
            height: "48px",
            padding: "0px 28px",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            borderRadius: "60px",
            backgroundColor: "secondary",
            boxShadow: "0px 0px 0px 4px #3962351a",
            color: "background",
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "16px",
          },
          typography: "Default",
        },
      ],
    },
    // Right content - Image
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        flex: "1",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/product-detail.png",
          alt: "Product Detail",
          styles: {
            width: "100%",
            objectFit: "contain",
          },
          responsiveStyles: {
            tablet: {
              display: "none",
            },
            mobile: {
              display: "none",
            },
          },
        },
      ],
    },
  ],
});

const createFeaturesSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "70px 100px 46px 10px",
    backgroundImage: "url('/template3/feature-background.png')", // Add background image
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    gap: "40px",
  },
  responsiveStyles: {
    tablet: {
      padding: "0px 12px 40px",
      gap: "24px",
    },
    mobile: {
      padding: "0px 12px 30px",
      gap: "24px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        alignItems: "center",
        gap: "0px",
      },
      children: [
        //Left Section
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            maxWidth: "600px",
            width: "100%",
          },
          responsiveStyles: {
            tablet: {
              display: "none",
            },
            mobile: {
              display: "none",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/klos-bottle.png",
              alt: "Feature Icon",
              styles: {
                width: "100%",
                height: "758px",
                objectFit: "contain",
              },
            },
          ],
        },
        //Right Section
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "35px",
          },
          responsiveStyles: {
            tablet: {
              gap: "24px",
            },
            mobile: {
              gap: "24px",
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/ingredient-icon.svg", // Assuming an icon for ingredients
                  alt: "Ingredients Icon",
                  styles: {
                    width: "24px",
                    height: "24px",
                    objectFit: "contain",
                  },
                },
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "Inhaltsstoffe",
                  styles: {
                    color: "secondary",
                    textAlign: "center",
                    fontFamily: "Open Sans",
                    fontSize: "34px",
                    fontStyle: "normal",
                    fontWeight: "800",
                    lineHeight: "140%",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/klos-bottle.png",
              alt: "Feature Icon",
              styles: {
                width: "90%",
                height: "100%",
                objectFit: "contain",
                display: "none",
              },
              responsiveStyles: {
                tablet: {
                  display: "none",
                },
                mobile: {
                  display: "none",
                },
              },
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                gap: "40px",
                width: "100%",
                maxWidth: "1200px", // Limit width for better readability
                flexWrap: "wrap", // Allow wrapping on smaller screens
              },
              responsiveStyles: {
                tablet: {
                  gap: "24px",
                },
                mobile: {
                  gap: "24px",
                },
              },
              children: [
                // Left Column
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "43px",
                    flex: "1",
                    minWidth: "300px", // Minimum width for each column
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg", // Checkmark icon
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Zink",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Unterstützt den normalen Stoffwechsel und trägt zur Erhaltung normaler Haut, Haare und Nägel bei.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Chrom",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Trägt zur Aufrechterhaltung eines normalen Blutzuckerspiegels bei und unterstützt den Makronährstoff-Stoffwechsel.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Mariendistel (Silymarin)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Unterstützt die Leberfunktion und hilft beim natürlichen Entgiftungsprozess.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Resveratrol",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Pflanzliches Antioxidans, bekannt aus Rotwein; unterstützt die Zellgesundheit und wirkt entzündungshemmend.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Koreanischer Ginseng",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Traditionell zur Steigerung von Energie und Ausdauer eingesetzt; kann bei Müdigkeit helfen.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                // Right Column
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "43px",
                    flex: "1",
                    minWidth: "300px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "20px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Grüner Tee Extrakt (EGCG)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Enthält Catechine, die den Fettstoffwechsel aktivieren und den Kalorienverbrauch erhöhen können.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Alpha-Liponsäure",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Trägt zur Aufrechterhaltung eines normalen Blutzuckerspiegels bei und unterstützt den Makronährstoff-Stoffwechsel.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Berberin",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Kann den Blutzuckerspiegel regulieren und den Fettstoffwechsel positiv beeinflussen.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Cayenne (Capsaicin)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Fördert die Thermogenese (Wärmebildung im Körper) und kann die Fettverbrennung unterstützen.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "12px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "image" as ElementType,
                          src: "/template3/check-icon.svg",
                          alt: "Checkmark",
                          styles: {
                            width: "17px",
                            height: "17px",
                            objectFit: "contain",
                            flexShrink: "0",
                            marginTop: "6px",
                          },
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "Königinblume (Coroosolsäure)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "22px",
                                fontStyle: "normal",
                                fontWeight: "700",
                                lineHeight: "140%",
                              },
                              typography: "Heading-5",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Wird mit Blutzuckerregulation in Verbindung gebracht; wirkt entzündungshemmend.",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "18px",
                                fontStyle: "normal",
                                fontWeight: "400",
                                lineHeight: "140%",
                              },
                              typography: "Body",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createPricingSectionContainer = (globalConfig: GlobalConfig) => ({
  id: 'pricing-section',
  type: "container" as ElementType,
  sectionName: "Pricing Section",
  isLinkableSection: true,
  styles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "112px 0 40px",
    backgroundColor: "background",
    width: "100%",
    gap: "32px",
  },
  responsiveStyles: {
    tablet: {
      padding: "40px 0 20px",
      maxWidth: "95%",
      margin: "0 auto",
    },
    mobile: {
      padding: "40px 0 20px",
      maxWidth: "95%",
      margin: "0 auto",
    },
  },
  children: [
    // Title and subtitle
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        marginBottom: "80px",
      },
      responsiveStyles: {
        tablet: {
          marginBottom: "0px",
        },
        mobile: {
          marginBottom: "0px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
          },
          responsiveStyles: {
            tablet: {
              alignItems: "flex-start",
              gap: "6px",
            },
            mobile: {
              alignItems: "flex-start",
              gap: "0px",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/price-tag.svg",
              alt: "header-icon",
              styles: {
                width: "32px",
                height: "32px",
                objectFit: "contain",
                marginTop: "0px",
              },
              responsiveStyles: {
                tablet: {
                  marginTop: "2px",
                },
                mobile: {
                  marginTop: "0px",
                },
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Entscheide dich für dein Klosterformel-Paket",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "34px",
                fontWeight: "800",
                lineHeight: "48px",
                color: "secondary",
                margin: "0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "32px",
                  lineHeight: "36px",
                },
                mobile: {
                  fontSize: "30px",
                  lineHeight: "34px",
                },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Starte heute – über 70 % wählen das 90-Tage-Paket für beste Ergebnisse und maximalen Preisvorteil.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "32px",
            color: "#000000",
            margin: "0",
            textAlign: "center",
          },
          typography: "Body",
          responsiveStyles: {
            tablet: {
              lineHeight: "24px",
            },
            mobile: {
              lineHeight: "24px",
            },
          },
        },
      ],
    },
    // Pricing cards row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "stretch",
        gap: "32px",
        width: "100%",
        maxWidth: "1200px",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: {
          marginTop: "50px",
        },
      },
      children: [
        // 1-Monats-Paket
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            marginTop: "70px",
            backgroundColor: "background",
            borderRadius: "10px",
            padding: "42px 32px 24px",
            width: "100%",
            maxWidth: "420px",
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0",
            border: "6px solid #BBB9BA",
          },
          responsiveStyles: {
            tablet: {
              marginTop: "0px",
              order: 1,
            },
            mobile: {
              marginTop: "0px",
              order: 1,
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flex: "1",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "0",
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0",
                  },
                  children: [
                    // Header
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "0",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "1-Monats-Paket",
                          styles: {
                            fontFamily: "Open Sans",
                            fontSize: "25px",
                            lineHeight: "24px",
                            fontWeight: "700",
                            color: "#565656",
                            margin: "0",
                            textAlign: "center",
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Für alle, die es erstmal ausprobieren möchten.",
                          styles: {
                            fontFamily: "Open Sans",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: "400",
                            color: "#3B82F6",
                            margin: "0",
                            textAlign: "center",
                            paddingBottom: "16px",
                            borderBottom: "3px solid #BBB9BA",
                          },
                          typography: "Default",
                        },
                      ],
                    },
                    // Image Section
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/bottle-single.png",
                      alt: "1-Monats-Paket",
                      styles: {
                        width: "100%",
                        objectFit: "contain",
                        margin: "27px 0 17px",
                      },
                    },
                    // Pricing section
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        alignSelf: "flex-start",
                        gap: "16px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "69.95€",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "50px",
                                fontWeight: "700",
                                lineHeight: "100%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                              typography: "Heading-2",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PRO PACKUNG",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "30px",
                                fontWeight: "700",
                                lineHeight: "125%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "Gesamtpreis: 69,95 € (1 × 69,95 €)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "144%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Ersparnis gegenüber Einzelpreis: 30,00 €",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "144%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                          ],
                        },
                        // Highlights
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            margin: "12px 0",
                            alignItems: "flex-start",
                          },
                          children: [
                            ...[
                              "1 Flasche – reicht für 30 Tage",
                              "Ideal, um die Wirkung kennenzulernen",
                              "2,33 € pro Tag",
                              "Kein Preisvorteil",
                              "60 Tage Rückgaberecht",
                            ].map((text) => ({
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "image" as ElementType,
                                  src: "/template3/check-icon.svg",
                                  alt: "Check",
                                  styles: {
                                    width: "16px",
                                    height: "16px",
                                    objectFit: "contain",
                                  },
                                },
                                {
                                  id: generateId(),
                                  type: "paragraph" as ElementType,
                                  content: text,
                                  styles: {
                                    fontSize: "15px",
                                    color: "#222",
                                    margin: "0",
                                  },
                                },
                              ],
                            })),
                          ],
                        },
                      ],
                    },
                  ],
                },
                //Footer section
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                  },
                  children: [
                    // Button
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "JETZT BESTELLEN",
                      styles: {
                        width: "100%",
                        padding: "12px 24px",
                        backgroundColor: "#BBB9BA",
                        color: "background",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "150%",
                        border: "none",
                        margin: "12px 0 0 0",
                        cursor: "pointer",
                      },
                      typography: "Default",
                    },
                    // Guarantee
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "100% 60 Tage Geld Zurück Garantie",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#000000",
                        margin: "0",
                        textAlign: "center",
                      },
                    },
                    // Payment icons
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/payment-icon.png",
                      alt: "Payment Icon",
                      styles: {
                        width: "100%",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        // 6-Monats-Paket (highlighted)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundImage:
              "linear-gradient(180deg, #5DB74C -86.95%, #5db74c00 33.03%)",
            borderRadius: "10px",
            padding: "42px 32px 24px",
            width: "100%",
            maxWidth: "420px",
            flex: "1",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "0",
            border: "6px solid #30BD8E",
            position: "relative",
          },
          responsiveStyles: {
            tablet: {
              order: 0,
            },
            mobile: {
              order: 0,
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flex: "1",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "0",
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "MEISTGEWÄHLT",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: "700",
                    color: "tertiary",
                    backgroundColor: "#FFAC33",
                    borderRadius: "0px 0px 10px 10px",
                    padding: "13px 26px",
                    margin: "0",
                    textAlign: "center",
                    transform: "translateY(-85%)",
                  },
                  typography: "Default",
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0",
                  },
                  children: [
                    // Header
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "0",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "1-Monats-Paket",
                          styles: {
                            fontFamily: "Open Sans",
                            fontSize: "25px",
                            lineHeight: "24px",
                            fontWeight: "700",
                            color: "tertiary",
                            margin: "0",
                            textAlign: "center",
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Für alle, die es erstmal ausprobieren möchten.",
                          styles: {
                            fontFamily: "Open Sans",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: "400",
                            color: "tertiary",
                            margin: "0",
                            textAlign: "center",
                            paddingBottom: "16px",
                            borderBottom: "3px solid #101F0F",
                          },
                          typography: "Default",
                        },
                      ],
                    },
                    // Image Section
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/bottle-single.png",
                      alt: "1-Monats-Paket",
                      styles: {
                        width: "100%",
                        objectFit: "contain",
                        margin: "27px 0 17px",
                      },
                    },
                    // Pricing section
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        alignSelf: "flex-start",
                        gap: "16px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "69.95€",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "50px",
                                fontWeight: "700",
                                lineHeight: "100%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                              typography: "Heading-2",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PRO PACKUNG",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "30px",
                                fontWeight: "700",
                                lineHeight: "125%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "Gesamtpreis: 69,95 € (1 × 69,95 €)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "144%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Ersparnis gegenüber Einzelpreis: 30,00 €",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "144%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                          ],
                        },
                        // Highlights
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            margin: "12px 0",
                            alignItems: "flex-start",
                          },
                          children: [
                            ...[
                              "1 Flasche – reicht für 30 Tage",
                              "Ideal, um die Wirkung kennenzulernen",
                              "2,33 € pro Tag",
                              "Kein Preisvorteil",
                              "60 Tage Rückgaberecht",
                            ].map((text) => ({
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "image" as ElementType,
                                  src: "/template3/check-icon.svg",
                                  alt: "Check",
                                  styles: {
                                    width: "16px",
                                    height: "16px",
                                    objectFit: "contain",
                                  },
                                },
                                {
                                  id: generateId(),
                                  type: "paragraph" as ElementType,
                                  content: text,
                                  styles: {
                                    fontSize: "15px",
                                    color: "#222",
                                    margin: "0",
                                  },
                                },
                              ],
                            })),
                          ],
                        },
                      ],
                    },
                  ],
                },
                //Footer section
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    marginTop: "auto",
                  },
                  children: [
                    // Button
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "JETZT BESTELLEN",
                      styles: {
                        width: "100%",
                        padding: "12px 24px",
                        backgroundColor: "#30BD8E",
                        color: "background",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "150%",
                        border: "none",
                        margin: "12px 0 0 0",
                        cursor: "pointer",
                      },
                      typography: "Default",
                    },
                    // Guarantee
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "100% 60 Tage Geld Zurück Garantie",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#000000",
                        margin: "0",
                        textAlign: "center",
                      },
                    },
                    // Payment icons
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/payment-icon.png",
                      alt: "Payment Icon",
                      styles: {
                        width: "100%",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/badge.png",
              alt: "Badge img",
              styles: {
                width: "144px",
                height: "144px",
                objectFit: "contain",
                position: "absolute",
                right: "0",
                top: "0",
                transform: "translate3d(50%, -50%, 0)",
              },
              responsiveStyles: {
                tablet: {
                  // display: "none",    width: "144px",
                  width: "70px",
                  height: "70px",
                },
                mobile: {
                  display: "none",
                },
              },
            },
          ],
        },
        // 3-Monats-Paket
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            marginTop: "70px",
            backgroundColor: "background",
            borderRadius: "10px",
            padding: "42px 32px 24px",
            width: "100%",
            maxWidth: "420px",
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "0",
            border: "6px solid #BBB9BA",
          },
          responsiveStyles: {
            tablet: {
              marginTop: "0px",
              order: 2,
            },
            mobile: {
              marginTop: "0px",
              order: 2,
            },
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                flex: "1",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "0",
              },
              children: [
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0",
                  },
                  children: [
                    // Header
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "0",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "heading" as ElementType,
                          content: "1-Monats-Paket",
                          styles: {
                            fontFamily: "Open Sans",
                            fontSize: "25px",
                            lineHeight: "24px",
                            fontWeight: "700",
                            color: "#565656",
                            margin: "0",
                            textAlign: "center",
                          },
                        },
                        {
                          id: generateId(),
                          type: "paragraph" as ElementType,
                          content:
                            "Für alle, die es erstmal ausprobieren möchten.",
                          styles: {
                            fontFamily: "Open Sans",
                            fontSize: "16px",
                            lineHeight: "24px",
                            fontWeight: "400",
                            color: "#3B82F6",
                            margin: "0",
                            textAlign: "center",
                            paddingBottom: "16px",
                            borderBottom: "3px solid #BBB9BA",
                          },
                          typography: "Default",
                        },
                      ],
                    },
                    // Image Section
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/bottle-single.png",
                      alt: "1-Monats-Paket",
                      styles: {
                        width: "100%",
                        objectFit: "contain",
                        margin: "27px 0 17px",
                      },
                    },
                    // Pricing section
                    {
                      id: generateId(),
                      type: "container" as ElementType,
                      styles: {
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        alignSelf: "flex-start",
                        gap: "16px",
                      },
                      children: [
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "4px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "heading" as ElementType,
                              content: "69.95€",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "50px",
                                fontWeight: "700",
                                lineHeight: "100%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                              typography: "Heading-2",
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "PRO PACKUNG",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "30px",
                                fontWeight: "700",
                                lineHeight: "125%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                          ],
                        },
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            flex: "1",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "0px",
                          },
                          children: [
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content: "Gesamtpreis: 69,95 € (1 × 69,95 €)",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "144%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                            {
                              id: generateId(),
                              type: "paragraph" as ElementType,
                              content:
                                "Ersparnis gegenüber Einzelpreis: 30,00 €",
                              styles: {
                                fontFamily: "Open Sans",
                                fontSize: "14px",
                                fontWeight: "400",
                                lineHeight: "144%",
                                color: "primary",
                                margin: "0",
                                textAlign: "left",
                              },
                            },
                          ],
                        },
                        // Highlights
                        {
                          id: generateId(),
                          type: "container" as ElementType,
                          styles: {
                            display: "flex",
                            flexDirection: "column",
                            gap: "8px",
                            margin: "12px 0",
                            alignItems: "flex-start",
                          },
                          children: [
                            ...[
                              "1 Flasche – reicht für 30 Tage",
                              "Ideal, um die Wirkung kennenzulernen",
                              "2,33 € pro Tag",
                              "Kein Preisvorteil",
                              "60 Tage Rückgaberecht",
                            ].map((text) => ({
                              id: generateId(),
                              type: "container" as ElementType,
                              styles: {
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              },
                              children: [
                                {
                                  id: generateId(),
                                  type: "image" as ElementType,
                                  src: "/template3/check-icon.svg",
                                  alt: "Check",
                                  styles: {
                                    width: "16px",
                                    height: "16px",
                                    objectFit: "contain",
                                  },
                                },
                                {
                                  id: generateId(),
                                  type: "paragraph" as ElementType,
                                  content: text,
                                  styles: {
                                    fontSize: "15px",
                                    color: "#222",
                                    margin: "0",
                                  },
                                },
                              ],
                            })),
                          ],
                        },
                      ],
                    },
                  ],
                },
                //Footer section
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                  },
                  children: [
                    // Button
                    {
                      id: generateId(),
                      type: "button" as ElementType,
                      content: "JETZT BESTELLEN",
                      styles: {
                        width: "100%",
                        padding: "12px 24px",
                        backgroundColor: "#BBB9BA",
                        color: "background",
                        fontWeight: "700",
                        fontSize: "16px",
                        lineHeight: "150%",
                        border: "none",
                        margin: "12px 0 0 0",
                        cursor: "pointer",
                      },
                      typography: "Default",
                    },
                    // Guarantee
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "100% 60 Tage Geld Zurück Garantie",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "12px",
                        fontWeight: "700",
                        color: "#000000",
                        margin: "0",
                        textAlign: "center",
                      },
                    },
                    // Payment icons
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/payment-icon.png",
                      alt: "Payment Icon",
                      styles: {
                        width: "100%",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createBonusOfferSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "50px 80px",
    gap: "40px",
    backgroundColor: "background",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "20px 0",
      margin: "0 auto",
      gap: "30px",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px 0 40px",
      margin: "0 auto",
      gap: "20px",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
      },
      responsiveStyles: {
        tablet: {
          gap: "14px",
        },
        mobile: {
          gap: "0px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            gap: "28px",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/quotes.svg",
              alt: "quotes",
              styles: {
                width: "auto",
                height: "100%",
                objectFit: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Exklusive Bonus Bücher",
              styles: {
                color: "secondary",
                textAlign: "center",
                fontFamily: "Open Sans",
                fontSize: "34px",
                fontStyle: "normal",
                fontWeight: "800",
                lineHeight: "48px",
                margin: "0",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "30px",
                },
                mobile: {
                  fontSize: "24px",
                },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Entdecken Sie unsere wertvollen Extras für Ihre Gesundheit",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontWeight: "400",
            color: "#3B82F6",
            margin: "0",
            textAlign: "center",
            lineHeight: "32px",
            fontStyle: "normal",
          },
          typography: "Body",
          responsiveStyles: {
            tablet: {
              lineHeight: "28px",
            },
            mobile: {
              lineHeight: "24px",
            },
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: "70px",
        flexWrap: "wrap",
        width: "100%",
      },
      responsiveStyles: {
        tablet: {
          gap: "40px",
        },
        mobile: {
          gap: "20px",
        },
      },
      children: [
        // Bonus Card 1
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px #0000001a",
            width: "100%",
            maxWidth: "600px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "20px",
            boxSizing: "border-box",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#3BA4FF",
                width: "100%",
                padding: "20px 4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px 8px 0 0",
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Bonus #1 - Gratis im 3- & 6-Monats-Paket enthalten",
                  styles: {
                    color: "background",
                    fontFamily: "Open Sans",
                    fontSize: "20px",
                    fontWeight: "700",
                    lineheight: "26px",
                    fontStyle: "normal",
                    margin: "0",
                    textAlign: "center",
                  },
                  typography: "Heading-6",
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "100%",
                height: "250px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#D1C2B5",
              },
              responsiveStyles: {
                tablet: {
                  height: "200px",
                },
                mobile: {
                  height: "155px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/book1.png", // Replace with actual image path
                  alt: "7 TAGE STOFFWECHSEL BOOSTER",
                  styles: {
                    width: "100%",
                    objectFit: "cover",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "30px",
                padding: "34px 70px",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  gap: "24px",
                  padding: "25px",
                },
                mobile: {
                  gap: "16px",
                  padding: "15px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "7 TAGE STOFFWECHSEL BOOSTER",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "27px",
                    fontWeight: "800",
                    lineHeight: "38px",
                    color: "#000000",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "24px",
                      lineHeight: "30px",
                    },
                    mobile: {
                      fontSize: "24px",
                      lineHeight: "30px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    textAlign: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Statt: 49€",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        color: "#FF0000",
                        textDecoration: "line-through",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "18px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Heute: GRATIS",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "24px",
                        fontWeight: "700",
                        lineHeight: "20px",
                        color: "#000000",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                        },
                        mobile: {
                          fontSize: "20px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Entdecken Sie in diesem kompakten 7-Tage-Programm, wie Sie Ihren Stoffwechsel jeden Tag gezielt aktivieren – mit einfachen Ritualen, die Ihren Körper auf natürliche Weise neu programmieren.",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    color: "primary",
                    margin: "0",
                    lineHeight: "34px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                      lineHeight: "30px",
                    },
                    mobile: {
                      fontSize: "18px",
                      lineHeight: "26px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Digitales Format",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "34px",
                    color: "#8B8B8B",
                    margin: "0",
                    marginTop: "15px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                    },
                    mobile: {
                      fontSize: "18px",
                    },
                  },
                },
              ],
            },
          ],
        },
        // Bonus Card 2
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "8px",
            boxShadow: "0px 4px 10px #0000001a",
            width: "100%",
            maxWidth: "600px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: "20px",
            boxSizing: "border-box",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                backgroundColor: "#3BA4FF",
                width: "100%",
                padding: "20px 4px",
                display: "flex",
                borderRadius: "8px 8px 0 0",
                justifyContent: "center",
                alignItems: "center",
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Bonus #2 - Exklusiv im 6-Monats-Paket enthalten",
                  styles: {
                    color: "background",
                    fontFamily: "Open Sans",
                    fontSize: "20px",
                    fontWeight: "700",
                    lineheight: "26px",
                    fontStyle: "normal",
                    margin: "0",
                    textAlign: "center",
                  },
                  typography: "Heading-6",
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                width: "100%",
                height: "250px",
                overflow: "hidden",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#D1C2B5",
              },
              responsiveStyles: {
                tablet: {
                  height: "200px",
                },
                mobile: {
                  height: "155px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/book2.png", // Replace with actual image path
                  alt: "DEIN KÖRPER ALS PARTNER",
                  styles: {
                    width: "100%",
                    objectFit: "cover",
                  },
                },
              ],
            },
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "30px",
                padding: "34px 70px",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  gap: "24px",
                  padding: "25px",
                },
                mobile: {
                  gap: "16px",
                  padding: "15px",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "heading" as ElementType,
                  content: "DEIN KÖRPER ALS PARTNER",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "28px",
                    fontWeight: "800",
                    lineHeight: "38px",
                    color: "#000000",
                    margin: "0",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "24px",
                      lineHeight: "30px",
                    },
                    mobile: {
                      fontSize: "24px",
                      lineHeight: "30px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    textAlign: "center",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Statt: 49€",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "22px",
                        fontWeight: "400",
                        lineHeight: "20px",
                        color: "#FF0000",
                        textDecoration: "line-through",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "20px",
                        },
                        mobile: {
                          fontSize: "18px",
                        },
                      },
                    },
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Heute: GRATIS",
                      styles: {
                        fontFamily: "Open Sans",
                        fontSize: "24px",
                        fontWeight: "700",
                        lineHeight: "20px",
                        color: "#000000",
                        margin: "0",
                      },
                      responsiveStyles: {
                        tablet: {
                          fontSize: "22px",
                        },
                        mobile: {
                          fontSize: "20px",
                        },
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content:
                    "Ein tiefgehender Ratgeber, der Ihnen zeigt, wie Sie im Einklang mit Ihrem Körper leben – statt gegen ihn. Für mehr Energie, Vertrauen in Ihre Gesundheit und nachhaltige Balance.",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    color: "primary",
                    margin: "0",
                    lineHeight: "34px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                      lineHeight: "30px",
                    },
                    mobile: {
                      fontSize: "18px",
                      lineHeight: "26px",
                    },
                  },
                },
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Digitales Format",
                  styles: {
                    fontFamily: "Open Sans",
                    fontSize: "22px",
                    fontWeight: "400",
                    lineHeight: "34px",
                    color: "#8B8B8B",
                    margin: "0",
                    marginTop: "15px",
                  },
                  responsiveStyles: {
                    tablet: {
                      fontSize: "20px",
                    },
                    mobile: {
                      fontSize: "18px",
                    },
                  },
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});

const createCardDetailsSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "8px 40px 30px",
    backgroundColor: "background",
    gap: "20px",
    width: "100%",
  },
  responsiveStyles: {
    tablet: {
      padding: "8px 20px 30px",
    },
    mobile: {
      padding: "8px 10px 30px",
    },
  },
  children: [
    // Heading and subtitle
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        marginBottom: "16px",
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/quotes.svg",
              alt: "quotes",
              styles: {
                width: "auto",
                height: "100%",
                objectFit: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Das sagen unsere Kunden",
              styles: {
                color: "secondary",
                fontFamily: "Open Sans",
                fontSize: "34px",
                fontWeight: "800",
                lineHeight: "48px",
                margin: "0",
                textAlign: "center",
              },
              responsiveStyles: {
                tablet: {
                  fontSize: "30px",
                },
                mobile: {
                  fontSize: "22px",
                  lineHeight: "22px",
                },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "Entdecken Sie unsere wertvollen Extras für Ihre Gesundheit",
          styles: {
            color: "#3B82F6",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "32px",
            margin: "0",
            textAlign: "center",
          },
          typography: "Body",
        },
      ],
    },
    // Cards grid
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
        gap: "32px",
        width: "100%",
        maxWidth: "1200px",
        justifyContent: "center",
      },
      children: [
        // Card 1
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            backgroundColor: "background",
            borderRadius: "12px",
            boxShadow: "0 4px 16px #00000012",
            padding: "28px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            minHeight: "210px",
          },
          children: [
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "flex-start",
                gap: "12px",
              },
              children: [
                {
                  id: generateId(),
                  type: "image" as ElementType,
                  src: "/template3/person1.png",
                  alt: "Sabine M.",
                  styles: {
                    width: "55px",
                    height: "55px",
                    borderRadius: "50%",
                    objectFit: "cover",
                  },
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    flexDirection: "column",
                    gap: "0px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "heading" as ElementType,
                      content: "Sabine M.",
                      styles: {
                        fontSize: "20px",
                        fontWeight: "700",
                        lineHeight: "normal",
                        margin: "0",
                        color: "#222",
                      },
                      typography: "Heading-6",
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "52 Jahre Alt · Weiblich",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "München 🇩🇪",
                      styles: {
                        fontSize: "12px",
                        fontWeight: "400",
                        lineHeight: "normal",
                        textTransform: "capitalize",
                        color: "#6B6B6B",
                        margin: "0",
                      },
                    },
                  ],
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "4px",
                    marginLeft: "auto",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/tick-sucess.svg",
                      alt: "Green Color Tick Mark",
                      styles: {
                        width: "7px",
                        height: "7px",
                        objectFit: "cover",
                        marginTop: "2px",
                      },
                    },
                    {
                      id: generateId(),
                      type: "paragraph" as ElementType,
                      content: "Verifizierte Bewertung",
                      styles: {
                        fontSize: "10px",
                        fontWeight: "400",
                        lineHeight: "12px",
                        color: "quaternary",
                        maxWidth: "50px",
                      },
                    },
                  ],
                },
              ],
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "„Ich hätte nie gedacht, dass ich mich mit Anfang 50 nochmal so vital fülen kann. Die ersten Effekte kamen schleichend – mehr Energie, besserer Schlaf. Inzwischen gehört es zu meinem Alltag.“",
              styles: {
                color: "#294F3E",
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "23px",
                margin: "0",
                fontStyle: "normal",
              },
              typography: "Default",
            },
          ],
        },
      ],
    },
  ],
});

const createFaqSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "50px 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "30px 0",
      margin: "0 auto",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px 0",
      margin: "0 auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        backgroundColor: "background",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        marginBottom: "60px",
        boxSizing: "border-box",
      },
      responsiveStyles: {
        tablet: {
          marginBottom: "20px",
        },
        mobile: {
          marginBottom: "16px",
        },
      },
      children: [
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            marginBottom: "24px",
          },
          responsiveStyles: {
            tablet: {
              marginBottom: "14px",
            },
            mobile: {
              marginBottom: "10px",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/faq.png",
              alt: "FAQ",
              styles: {
                width: "32px",
                height: "32px",
                objectContain: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Frequently Asked Questions",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "34px",
                fontWeight: "700",
                lineHeight: "48px",
                color: "secondary",
                textAlign: "center",
              },
              typography: "Heading-3",
              responsiveStyles: {
                tablet: {
                  fontSize: "30px",
                  lineHeight: "32px",
                  textAlign: "left",
                },
                mobile: {
                  fontSize: "26px",
                  lineHeight: "28px",
                  textAlign: "left",
                },
              },
            },
          ],
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Bei weiteren Fragen steht unser Support gerne zur Verfügung!",
          styles: {
            fontFamily: "Inter",
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "32px",
            color: "#3B82F6",
            textAlign: "center",
          },
          typography: "Body",
          responsiveStyles: {
            tablet: {
              lineHeight: "28px",
            },
            mobile: {
              lineHeight: "24px",
            },
          },
        },
      ],
    },
    {
      id: generateId(),
      type: "accordion" as ElementType,
      allowMultiple: false,
      defaultOpen: false,
      accordionType: "single" as "single" | "multiple",
      // Icon configuration for all accordion items
      iconSrcCollapsed: "/template3/plus.svg",
      iconSrcExpanded: "/template3/minus.svg",
      // Icon styling
      iconStyles: {
        width: "24px",
        height: "24px",
        marginLeft: "16px",
      },
      styles: {
        width: "100%",
        maxWidth: "1200px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        border: "0",
      },
      children: [
        // FAQ items (collapsible)
        ...[
          {
            q: "Wie lange muss ich das Produkt einnehmen, um erste Ergebnisse zu spüren?",
            a: "Viele Kund:innen berichten über spürbare Verbesserungen nach 7-14 Tagen. Für nachhaltige Ergebnisse empfehlen wir mindestens 90 Tage.",
          },
          {
            q: "Was ist, wenn es bei mir nicht funktioniert?",
            a: "Sollten Sie keine Wirkung verspüren, kontaktieren Sie bitte unseren Support für eine individuelle Beratung.",
          },
          {
            q: "Gibt es bekannte Nebenwirkungen?",
            a: "Das Produkt ist gut verträglich. Bei Unsicherheiten oder Vorerkrankungen sprechen Sie bitte mit Ihrem Arzt.",
          },
          {
            q: "Kann ich das Produkt parallel zu anderen Nahrungsergänzungsmitteln einnehmen?",
            a: "In der Regel ja, aber bei Unsicherheiten oder Medikamenteneinnahme konsultieren Sie bitte Ihren Arzt.",
          },
          {
            q: "Wie nehme ich das Produkt ein?",
            a: "Die empfohlene Einnahme finden Sie auf dem Etikett. In der Regel 2 Kapseln täglich mit ausreichend Wasser.",
          },
          {
            q: "Wie viele Kapseln enthält eine Packung?",
            a: "Eine Packung enthält 60 Kapseln – ausreichend für einen Monat.",
          },
          {
            q: "Warum empfehlen so viele das 6-Monats-Paket?",
            a: "Für nachhaltige Ergebnisse und den besten Preis empfehlen wir das 6-Monats-Paket.",
          },
          {
            q: "Gibt es einen Rabatt, wenn ich mehr bestelle?",
            a: "Ja, beim Kauf von 3 oder 6 Packungen erhalten Sie einen attraktiven Mengenrabatt.",
          },
          {
            q: "Wie läuft der Versand ab?",
            a: "Der Versand erfolgt klimaneutral und in der Regel innerhalb von 1-3 Werktagen.",
          },
          {
            q: "Wohin liefert ihr?",
            a: "Wir liefern innerhalb Deutschlands, nach Österreich und in die Schweiz.",
          },
          {
            q: "Ist die Bezahlung sicher?",
            a: "Ja, alle Zahlungen sind SSL-verschlüsselt und sicher.",
          },
          {
            q: "Gibt es ein Abo oder versteckte Gebühren?",
            a: "Nein, es gibt kein Abo und keine versteckten Kosten.",
          },
          {
            q: "Sind die Kapseln vegan?",
            a: "Ja, unsere Kapseln sind 100% vegan.",
          },
          {
            q: "Wie wird das Produkt hergestellt?",
            a: "Das Produkt wird nach höchsten Qualitätsstandards in Deutschland hergestellt.",
          },
          {
            q: "Was unterscheidet dieses Produkt von anderen?",
            a: "Die einzigartige Rezeptur vereint altes Wissen mit moderner Wissenschaft.",
          },
        ].map((item, idx) => ({
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            border: "none",
            borderBottom: "1px solid #EDEDED",
            borderRadius: "0",
            background: "background",
            padding: "20px 28px",
            display: "flex",
            flexDirection: "column",
            gap: "18px",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            transition: "transform 0.2s cubic-bezier(.4,0,.2,1)",
            width: "100%",
            position: "relative", // Added for absolute positioned icon
          },
          responsiveStyles: {
            tablet: {
              padding: "16px",
            },
            mobile: {
              padding: "16px 8px",
            },
          },
          children: [
            // Simple question heading
            {
              id: generateId(),
              type: "heading" as ElementType,
              accordionRole: "question" as const,
              content: item.q,
              styles: {
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontWeight: "400",
                lineHeight: "147%",
                color: "tertiary",
                margin: "0",
                cursor: "pointer",
                width: "100%",
                display: "flex",
                alignItems: "center",
                padding: "0",
              },
              responsiveStyles: {
                tablet: { fontSize: "18px" },
                mobile: { fontSize: "16px" },
              },
            },
            // Answer element with accordion role
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              accordionRole: "answer" as const,
              content: item.a,
              styles: {
                margin: "0",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "170%",
                color: "#565656",
                width: "100%",
              },
              responsiveStyles: {
                tablet: { fontSize: "14px" },
                mobile: { fontSize: "14px" },
              },
            },
          ],
        })),
      ],
    },
  ],
});

const createBookmarksListSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    backgroundColor: "background",
    padding: "70px 40px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  responsiveStyles: {
    tablet: {
      maxWidth: "95%",
      padding: "30px",
      margin: "0 auto",
    },
    mobile: {
      maxWidth: "95%",
      padding: "20px",
      margin: "0 auto",
    },
  },
  children: [
    {
      id: generateId(),
      type: "heading" as ElementType,
      content: "Wissenschaftliche Referenzen",
      styles: {
        fontFamily: "Inter",
        fontSize: "32px",
        fontWeight: "700",
        color: "#222",
        marginBottom: "40px",
        textAlign: "center",
      },
      responsiveStyles: {
        tablet: {
          fontSize: "28px",
          marginBottom: "25px",
        },
        mobile: {
          fontSize: "24px",
          marginBottom: "20px",
        },
      },
    },
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        gap: "119px",
        width: "100%",
        maxWidth: "1109px",
        justifyContent: "center",
      },
      responsiveStyles: {
        tablet: {
          gap: "30px",
          flexDirection: "column",
        },
        mobile: {
          gap: "20px",
          flexDirection: "column",
        },
      },
      children: [
        // Left column (1-9)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "1. Dulloo, A. G., Jacquet, J., & Girardier, L. (1997). Poststarvation hyperphagia and body fat overshooting in humans: A role for feedback signals from lean and fat tissues. The American Journal of Clinical Nutrition, 65(3), 717–723. https://doi.org/10.1093/ajcn/65.3.717",
              href: "https://doi.org/10.1093/ajcn/65.3.717",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "2. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              href: "https://doi.org/10.18632/aging.100639",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "3. Wang, Y., & Wang, X. (2023). Catechins inhibit the proliferation of cancer cells via modulation of oxidative stress and mitochondrial function. Cell Biochemistry and Function, 41(2), 123–130. https://doi.org/10.1002/cbf.3384",
              href: "https://doi.org/10.1002/cbf.3384",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "4. Fink, R. L., Kolterman, O. G., Griffin, J., & Olefsky, J. M. (1983). Mechanisms of insulin resistance in aging. The Journal of Clinical Investigation, 71(6), 1523–1535. https://doi.org/10.1172/JCI110908",
              href: "https://doi.org/10.1172/JCI110908",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "5. Kusminski, C. M., Scherer, P. E., & Cawthorn, W. P. (2019). Brown and beige adipose tissue and aging. Frontiers in Endocrinology, 10, 368. https://doi.org/10.3389/fendo.2019.00368",
              href: "https://doi.org/10.3389/fendo.2019.00368",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                '6. American Journal of Clinical Nutrition. (n.d.). Search results for "catechins". Retrieved May 22, 2025, from https://ajcn.nutrition.org/action/doSearch?type=quicksearch&text=catechins&field1=AllField',
              href: "https://ajcn.nutrition.org/action/doSearch?type=quicksearch&text=catechins&field1=AllField",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "7. Green, B. G., & Schullery, M. T. (2012). The taste of catechins: Astringency and bitterness. Chemical Senses, 37(2), 103–110. https://doi.org/10.1093/chemse/bjr084",
              href: "https://doi.org/10.1093/chemse/bjr084",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "8. Janssens, P. L., Hursel, R., & Westerterp-Plantenga, M. S. (2020). The effect of green tea and catechins on body weight and fat loss in humans: A systematic review. Nutrients, 12(1), 157. https://doi.org/10.3390/nu12010157",
              href: "https://doi.org/10.3390/nu12010157",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "9. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              href: "https://doi.org/10.18632/aging.100639",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
          ],
        },
        // Right column (10-18)
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            flex: "1",
            minWidth: "340px",
            display: "flex",
            flexDirection: "column",
          },
          responsiveStyles: {
            tablet: {
              minWidth: "100%",
            },
            mobile: {
              minWidth: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "10. Smith, J. D., & Jones, A. B. (2020). Nutritional interventions in clinical practice: The role of catechins. Clinical Nutrition ESPEN, 35, 100–105. https://doi.org/10.1016/j.clnesp.2020.03.005",
              href: "https://doi.org/10.1016/j.clnesp.2020.03.005",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "11. Lee, M. H., & Kim, S. H. (2022). Catechins and their role in metabolic health: A review. Current Developments in Nutrition, 6(10), 100097. https://doi.org/10.1016/j.cdnut.2022.100097",
              href: "https://doi.org/10.1016/j.cdnut.2022.100097",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "12. Johnson, M. L., & Smith, K. L. (2023). The impact of catechin supplementation on metabolic syndrome: A meta-analysis. Frontiers in Nutrition, 10, 86443. https://doi.org/10.3389/fnut.2023.86443",
              href: "https://doi.org/10.3389/fnut.2023.86443",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "13. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              href: "https://doi.org/10.1016/j.jnutbio.2018.03.001",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "14. Kim, H. J., & Lee, S. Y. (2019). The role of catechins in metabolic syndrome: A review. Nutrition Research Reviews, 32(2), 1–10. https://doi.org/10.1017/S0954422419000156",
              href: "https://doi.org/10.1017/S0954422419000156",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "15. Park, Y. J., & Kim, Y. H. (2020). Catechins and their role in metabolic health: A systematic review. Nutrition Research and Practice, 14(1), 1–10. https://doi.org/10.4162/nrp.2020.14.1.1",
              href: "https://doi.org/10.4162/nrp.2020.14.1.1",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "16. Lee, J. H., & Park, S. Y. (2018). Catechins and their effect on metabolic health: A comprehensive review. Journal of Nutritional Biochemistry, 57, 1–10. https://doi.org/10.1016/j.jnutbio.2018.03.001",
              href: "https://doi.org/10.1016/j.jnutbio.2018.03.001",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "17. Poljsak, B., & Milisav, I. (2024). Decreasing intracellular entropy by increasing mitochondrial efficiency and reducing ROS formation: The effect on the ageing process and age-related damage. International Journal of Molecular Sciences, 25(12), 6321. https://doi.org/10.3390/ijms25126321",
              href: "https://doi.org/10.3390/ijms25126321",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
            {
              id: generateId(),
              type: "link" as ElementType,
              content:
                "18. Regmi, S. G., Rolland, S. G., & Conradt, B. (2014). Age-dependent changes in mitochondrial morphology and volume are not predictors of lifespan. Aging (Albany NY), 6(2), 118–130. https://doi.org/10.18632/aging.100639",
              href: "https://doi.org/10.18632/aging.100639",
              target: "_blank",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "400",
                color: "#222",
                lineHeight: "24px",
                margin: "0",

                padding: "0",
                textDecoration: "none",
                whiteSpace: "normal",
                wordBreak: "break-all",
              },
            },
          ],
        },
      ],
    },
  ],
});

const createKlosFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    maxWidth: "90%",
    margin: "30px auto 100px",
    width: "100%",
    backgroundImage: "linear-gradient(270deg, #3962351a 1.41%, #57977300 100%)",
    border: "4px solid #39623533",
    borderRadius: "16px",
    boxShadow: "0px 4px 19px 0px #00000014",
    padding: "40px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  responsiveStyles: {
    tablet: {
      margin: "30px auto 70px",
      padding: "30px",
    },
    mobile: {
      margin: "30px auto 50px",
      padding: "20px",
    },
  },
  children: [
    // Main content row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        gap: "0",
        boxSizing: "border-box",
      },
      responsiveStyles: {
        tablet: {
          flexDirection: "row",
        },
        mobile: {
          flexDirection: "column",
          gap: "16px",
        },
      },
      children: [
        // Left: Logo and text
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "32px",
            width: "60%",
          },
          responsiveStyles: {
            tablet: {
              width: "60%",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "image" as ElementType,
              src: "/template3/logo.png",
              alt: "Logo",
              styles: {
                width: "78px",
                height: "72px",
                objectFit: "contain",
              },
            },
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Starte deine Reise zu mehr Energie.",
              styles: {
                fontFamily: "Inter",
                fontSize: "26px",
                fontWeight: "400",
                color: "#565656",
                lineHeight: "36px",
                maxWidth: "400px",
              },
            },
            {
              id: generateId(),
              type: "paragraph" as ElementType,
              content:
                "Kein Heilversprechen. Nahrungsergänzungsmittel ersetzen keine ausgewogene Ernährung.",
              styles: {
                fontFamily: "Inter",
                fontSize: "20px",
                fontWeight: "400",
                color: "#6B6B6B",
                margin: "0",
                lineHeight: "28px",
                maxWidth: "450px",
              },
            },
          ],
        },
        // Middle: Links
        {
          id: generateId(),
          type: "container" as ElementType,
          styles: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: "0px",
            width: "40%",
          },
          responsiveStyles: {
            tablet: {
              flexDirection: "column",
            },
            mobile: {
              flexDirection: "column",
              width: "100%",
            },
          },
          children: [
            {
              id: generateId(),
              type: "heading" as ElementType,
              content: "Mehr über Klosterformel",
              styles: {
                fontFamily: "Open Sans",
                fontSize: "20px",
                fontWeight: "700",
                lineHeight: "32px",
                color: "#101f0fb3",
                marginBottom: "33px",
              },
              typography: "Heading-6",
            },
            ...[
              "Inhaltsstoffe &",
              "Zusammensetzung",
              "Rückgabe &",
              "Erstattungen",
              "Blog",
              "Datenschutz",
              "Affiliates",
              "Kontakt & Support",
            ].map((link) => ({
              id: generateId(),
              type: "paragraph" as ElementType,
              content: link,
              styles: {
                fontFamily: "Inter",
                fontSize: "16px",
                lineHeight: "36px",
                color: "#101f0fcc",
                margin: "0",
                cursor: "pointer",
                fontWeight: "400",
              },
              typography: "Default",
            })),
            // Payment partners row
            {
              id: generateId(),
              type: "container" as ElementType,
              styles: {
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginTop: "16px",
              },
              responsiveStyles: {
                tablet: {
                  flexDirection: "column",
                },
                mobile: {
                  flexDirection: "column",
                },
              },
              children: [
                {
                  id: generateId(),
                  type: "paragraph" as ElementType,
                  content: "Payment Partners :",
                  styles: {
                    fontFamily: '"Source Serif 4"',
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "28px",
                    color: "#898989",
                    margin: "0",
                  },
                  typography: "Button",
                },
                {
                  id: generateId(),
                  type: "container" as ElementType,
                  styles: {
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                  },
                  children: [
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/paypal.png", // Placeholder, add asset if available
                      alt: "PayPal",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/mastercard.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                    {
                      id: generateId(),
                      type: "image" as ElementType,
                      src: "/template3/visa.png", // Placeholder, add asset if available
                      alt: "Visa",
                      styles: {
                        height: "24px",
                        objectFit: "contain",
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    // Divider
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        height: "1px",
        backgroundColor: "#E6E6E6",
        margin: "24px 0 0 0",
      },
      children: [],
    },
    // Copyright and disclaimer
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "38px 0 0",
        gap: "16px",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content: "© 2025 Klosterformel. Alle Rechte vorbehalten.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene, abwechslungsreiche Ernährung und gesunde Lebensweise. Nicht empfohlen für Kinder, Schwangere oder Stillende.",
          styles: {
            fontFamily: "Open Sans",
            fontSize: "16px",
            fontWeight: "400",
            lineHeight: "28px",
            color: "#898989",
            margin: "0",
          },
          typography: "Default",
        },
      ],
    },
  ],
});

const createFooterSectionContainer = (globalConfig: GlobalConfig) => ({
  id: generateId(),
  type: "container" as ElementType,
  styles: {
    width: "100%",
    backgroundColor: "background",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0",
    margin: "0",
    boxSizing: "border-box",
  },
  children: [
    // Top black bar with links
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: "32px",
        padding: "12px 0",
        flexWrap: "wrap",
      },
      responsiveStyles: {
        tablet: {
          gap: "16px",
        },
        mobile: {
          flexDirection: "column",
          padding: "16px",
        },
      },
      children: [
        ...[
          { text: "Datenschutz", href: "/privacy-policy", type: "link" },
          {
            text: "Geschäftsbedingungen",
            href: "/terms-of-service",
            type: "link",
          },
          { text: "Haftungsausschluss", href: "/disclaimer", type: "link" },
          {
            text: "Produkteetikett",
            href: "#",
            type: "popup",
            triggerPopup: "klos-label",
          },
          {
            text: "Rückgabe und Rückerstattung",
            href: "/refund-policy",
            type: "link",
          },
          { text: "Kontakt", href: "/contact", type: "link" },
        ].map((link) => ({
          id: generateId(),
          type:
            link.type === "popup"
              ? ("button" as ElementType)
              : ("link" as ElementType),
          content: link.text,
          ...(link.type === "popup"
            ? {
                interactionType: "popup" as const,
                triggerPopup: link.triggerPopup,
              }
            : {
                href: link.href,
              }),
          styles: {
            color: "background",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "22px",
            margin: "0",
            cursor: "pointer",
            fontFamily: "Inter",
            textDecoration: "none",
            backgroundColor: "transparent",
            border: "none",
          },
          hoverStyles: {
            textDecoration: "underline",
          },
        })),
      ],
    },
    // Disclaimer text
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 16px 0",
        boxSizing: "border-box",
      },
      children: [
        {
          id: generateId(),
          type: "paragraph" as ElementType,
          content:
            "Die Aussagen auf dieser Website wurden nicht von der US-amerikanischen Gesundheitsbehörde FDA geprüft. Die Produkte sind nicht zur Diagnose, Behandlung, Heilung oder Vorbeugung von Krankheiten bestimmt. Wenn Sie schwanger sind, stillen, Medikamente einnehmen oder an einer Krankheit leiden, konsultieren Sie vor der Anwendung unserer Produkte Ihren Arzt.",
          styles: {
            color: "#444",
            fontSize: "16px",
            fontWeight: "400",
            textAlign: "center",
            fontFamily: "Poppins",
            maxWidth: "900px",
            margin: "0 auto",
            lineHeight: "24px",
          },
          typography: "Default",
        },
      ],
    },
    // Logos row
    {
      id: generateId(),
      type: "container" as ElementType,
      styles: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        margin: "24px 0 40px 0",
      },
      children: [
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/digistore24.svg",
          alt: "digistore24",
          styles: {
            height: "18px",
            objectFit: "contain",
            paddingRight: "12px",
            borderRight: "1px solid #5E5959",
            marginRight: "12px",
          },
        },
        {
          id: generateId(),
          type: "image" as ElementType,
          src: "/template3/secure-order.png",
          alt: "SECURE ORDER",
          styles: {
            height: "18px",
            objectFit: "contain",
          },
        },
      ],
    },
  ],
});

export const template3 = (globalConfig: GlobalConfig) => {
  return {
    header: createHeaderContainer(globalConfig),
    firstSection: createFirstSectionContainer(globalConfig),
    bannerSection: createBannerSectionContainer(globalConfig),
    detailSection: createDetailSectionContainer(globalConfig),
    featuresSection: createFeaturesSectionContainer(globalConfig),
    pricingSection: createPricingSectionContainer(globalConfig),
    bonusOfferSection: createBonusOfferSectionContainer(globalConfig),
    cardDetailsSection: createCardDetailsSectionContainer(globalConfig),
    faqSection: createFaqSectionContainer(globalConfig),
    bookmarksListSection: createBookmarksListSectionContainer(globalConfig),
    klosFooterSection: createKlosFooterSectionContainer(globalConfig),
    footerSection: createFooterSectionContainer(globalConfig),
  };
};
